import { render } from "./CalendarEmptyState.vue?vue&type=template&id=6219fe74&scoped=true"
import script from "./CalendarEmptyState.vue?vue&type=script&lang=ts"
export * from "./CalendarEmptyState.vue?vue&type=script&lang=ts"

import "./CalendarEmptyState.vue?vue&type=style&index=0&id=6219fe74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6219fe74"

export default script